import apiClient, { unwrap } from './client'
import type { DomainAcmeStatus, DomainTlsConfig, TlsCertInfo } from './types'

/**
 * 每域名 TLS / ACME API（单服务多域名）。
 * 后端字段为 snake_case（min_version / cert_path / acme_domains 等）。
 */
export const domainTlsApi = {
  get(domainId: number) {
    return unwrap<DomainTlsConfig>(apiClient.get(`/domains/${domainId}/tls`))
  },

  put(domainId: number, data: Partial<DomainTlsConfig>) {
    return unwrap<{ changed: number }>(apiClient.put(`/domains/${domainId}/tls`, data))
  },

  uploadCert(domainId: number, certFile: File, keyFile: File) {
    const form = new FormData()
    form.append('cert', certFile)
    form.append('key', keyFile)
    return unwrap<{ cert_path: string; key_path: string; cert: TlsCertInfo }>(
      apiClient.post(`/domains/${domainId}/tls/certificates`, form),
    )
  },

  test(domainId: number) {
    return unwrap<{ ok: boolean; cert?: TlsCertInfo; error?: string }>(
      apiClient.post(`/domains/${domainId}/tls/test`),
    )
  },

  acmeStatus(domainId: number) {
    return unwrap<DomainAcmeStatus>(apiClient.get(`/domains/${domainId}/tls/acme/status`))
  },

  issueAcme(domainId: number) {
    return unwrap<{ message: string }>(apiClient.post(`/domains/${domainId}/tls/acme/issue`))
  },
}